import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './App.css'
import App from './App.tsx'
import { GitHubAuthProvider } from './contexts/GitHubAuthContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <GitHubAuthProvider>
        <App />
      </GitHubAuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
